import { SOCKET_EVENT_NAME } from '../../../common/constants/global';
import { OPTIONS_STORE_PRE_SALE_LOCKS } from '@/vuex/module/preSaleLocks';

let socketInstance = null;
let storeInstance = null;

const handleLockUpdate = (locks = []) => {
  if (!storeInstance) {
    return;
  }

  storeInstance.dispatch(OPTIONS_STORE_PRE_SALE_LOCKS.ACTIONS.SET_LOCKS, locks || []);
};

export const initializePreSaleLockSocket = ({ socket, store }) => {
  if (!socket || !store) {
    return;
  }

  if (socketInstance && socketInstance !== socket) {
    socketInstance.off(SOCKET_EVENT_NAME.UPDATE_PRE_SALE_LOCK, handleLockUpdate);
  }

  socketInstance = socket;
  storeInstance = store;
  socketInstance.off(SOCKET_EVENT_NAME.UPDATE_PRE_SALE_LOCK, handleLockUpdate);
  socketInstance.on(SOCKET_EVENT_NAME.UPDATE_PRE_SALE_LOCK, handleLockUpdate);
};

export const lockPreSale = (idPreVenda) => {
  return new Promise((resolve, reject) => {
    if (!socketInstance) {
      reject(new Error('Socket não disponível'));

      return;
    }

    socketInstance.emit(SOCKET_EVENT_NAME.LOCK_PRE_SALE, { idPreSale: idPreVenda }, (response) => {
      resolve(response || {});
    });
  });
};

export const unlockPreSale = (idPreVenda) => {
  return new Promise((resolve, reject) => {
    if (!socketInstance) {
      reject(new Error('Socket não disponível'));

      return;
    }

    socketInstance.emit(
      SOCKET_EVENT_NAME.UNLOCK_PRE_SALE,
      { idPreSale: idPreVenda },
      (response) => {
        resolve(response || {});
      }
    );
  });
};

export const refreshPreSaleLock = (idPreVenda) => {
  return new Promise((resolve, reject) => {
    if (!socketInstance) {
      reject(new Error('Socket não disponível'));

      return;
    }

    socketInstance.emit(
      SOCKET_EVENT_NAME.REFRESH_PRE_SALE_LOCK,
      { idPreSale: idPreVenda },
      (response) => {
        resolve(response || {});
      }
    );
  });
};

export const requestInitialPreSaleLocks = () => {
  if (socketInstance && socketInstance.connected) {
    socketInstance.emit(SOCKET_EVENT_NAME.REQUEST_PRE_SALE_LOCKS);
  }
};

export const resetPreSaleLockSocket = () => {
  if (socketInstance) {
    socketInstance.off(SOCKET_EVENT_NAME.UPDATE_PRE_SALE_LOCK, handleLockUpdate);
  }

  socketInstance = null;
  storeInstance = null;
};
